<template>
  <UiSelect
    v-model="sortBy"
    :items="sortOptions"
    name="sortBy"
    hide-details
    dropdown-classes="w-45.5 float-right !bg-primary !p-4 !border-primary !space-y-2"
  >
    <template #activator="{ selectedItem, open }">
      <button class="relative flex items-center gap-1 text-xs uppercase">
        <span class="inline-flex items-center"> {{ $t("sortBy") }} </span>
        <span v-if="selectedItem" class="flex-auto flex items-center">
          ({{
            Array.isArray(selectedItem)
              ? selectedItem.map((item) => item?.label).join(", ")
              : selectedItem.label
          }})
        </span>
        <UiIcon
          :name="open ? 'chevron_up' : 'chevron_down'"
          class="pointer-events-none size-3 flex-shrink-0"
        />
      </button>
    </template>
    <template #item="{ item, selected }">
      <UiButton
        class="w-full font-normal"
        :class="{ 'border-black-40 text-black-40': !selected }"
        color="white"
        variant="outlined"
        size="sm"
      >
        {{ item.label }}
      </UiButton>
    </template>
  </UiSelect>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{ btnClasses?: string; isEngagement?: boolean }>(),
  {
    btnClasses: "",
    isEngagement: false,
  },
);
const { sortOptions, sortBy } = useCatalogFilters({
  isEngagement: props.isEngagement,
});
defineEmits(["onChangeSort"]);
</script>
